import { LetterAttachmentModel } from "./letter-attachment.model";

export enum FileStatus {
    Reading = 0,
    Uploading = 1,
    Converting = 2,
    Done = 3,
    Failed = 4
}

export interface UploadFile {
    id: string;
    name: string;
    size: number;
    type: string;
    progress: number;
    status: FileStatus;
    nativeFile: File;
    fileResult?: Blob;
    deleteKey?: LetterAttachmentModel; //UploadResponse;
}

// export interface UploadResponse {
//     Id: number;
//     Filename: string;
//     Key: string;
// }
